import * as Sentry from '@sentry/nextjs';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { type FC, useEffect } from 'react';
import { AuthTransition } from '@/Module/Auth/Component';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { preparePageTitle } from '@/Module/Core/Helper';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const WAITING_TIME = 10; // 10 seconds

const Transition: FC = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const isTransitioning = useAppSelector(state => state.auth.isTransitioning);
  useEffect(() => {
    if (!isTransitioning) return;
    const timeout = setTimeout(() => {
      if (isTransitioning) {
        dispatch(authSetIsTransitioningAction(false));
        const message = `Transition did not reset after ${WAITING_TIME} seconds in "${router.asPath}" address.`;
        Sentry.captureEvent({
          message,
          level: 'error',
          logger: 'TransitionComponent'
        });
      }
    }, WAITING_TIME * 1000);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeout);
  }, [isTransitioning, dispatch]);
  if (!isTransitioning) return null;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="Transition.tsx">
        <title>{preparePageTitle('انتقال')}</title>
      </Head>

      <div className="z-[300] flex h-screen items-center justify-center">
        <AuthTransition data-sentry-element="AuthTransition" data-sentry-source-file="Transition.tsx" />
      </div>
    </>;
};
export default Transition;